export class ProfileGeneralLang {

    public static general = {
        requiredField: 26,
        edit: 'Edit',
        update: 'Update',
        selectFile: 'Select File',
        
    }

    public static profile = {
        profile: 0,
        generalData: 1,
        firstName: 6,
        lastName: 7,
        email: 15,
        password: 8,
        contactNo: 'Contact Number',
        company: 'Company',
        vatNo: 'Vat Number',
        Headquarter: 'Headquarters',
        businessSize: 'Business Size',
        businessSize0: 'Select Business Size',
        businessSize1: 'Company with < of 50 collaborators',
        businessSize2: 'Company with collaborators between 50 and 100',
        businessSize3: 'Company with > 100 collaborators',
        businessSize4: 'Company with > 200 collaborators',
        profileImage: 9,

    }

}

export class ProfileUserLang {

    public static general = {
        requiredField: 26,
        edit: 'Edit',
        update: 'Update',
        selectFile: 'Select File',
        modify: 2,
        delete: 4,
        submit: 37,
        close: 17,
        selCol: 9,
        selectAll: 10,
        activeCol: 11,
        exportCsv: 13,
        exportPdf: 14,
        exportExc: 15,
        print: 16,
        confirmTitle: 'User Confirmation',
        confirmText: 36,
        ok: 'OK',
        cancel: 'Cancel',
    }

    public static user = {
        heading: 2,
        sNo: 'S.No',
        profile: 0,
        email: 15,
        firstName: 6,
        lastName: 7,
        actions: 32,
        addUser: 13,
        password: 8,
        profileImage: 9,
        sections: 16,
        readOnly: 17,
        readWrite: 18,
        deny: 19,
        deadlines: 20,
        servicing: 21,
        humanRes: 22,
        measTools: 23,
        probSolv: 24,
        docMang: 25,
        customers: 26,
        consultancy: 27,
        academy: 28,
        project: 29,
        audit: 30,
    }

}